import React from 'react';
import './App.css';
import image1 from './image_1.png'; // Update the path to your image file
import image2 from './image.png'; // Update the path to your image file

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="image-container">
          <img src={image1} alt="bub" style={{ width: '100px', height: '150px' }}className="image-left" />
          <p>
            Happy Valentine's Savannah 😮❤️
          </p>
          <img src={image2} alt="bink" style={{ width: '160px', height: '150px' }} className="image-right" />
        </div>
      </header>
    </div>
  );
}

export default App;